module.exports = __webpack_public_path__ + "img/version.18aeef3f.svg";